import { useEffect, useState, useContext } from "react";
import { Route } from "react-router-dom";

import { AppContexts } from "../../providers/";

import AppLayout from "./app-layout";
import Header from "../standard/header";
import Sidebar from "../standard/sidebar";
import Loading from "../common/Loading";

import ViewportBox from "../ui-kit/components/viewport-box";
import LineClamp from "../ui-kit/components/line-clamp";
import AnnouncementModal from "../common/AnnouncementModal";

import UtilsService from "../../services/util.service.js";

import { ThreadStatus } from "ruebarue-utils/thread-status.js";

const tone = new Audio(
  "https://s3.us-east-2.amazonaws.com/uploads.ruebarue.com/notification-tone.mp3",
);

const AppLoader = () => {
  const { user, inbox, inboxes, refresh, loading } = useContext(
    AppContexts.AuthContext,
  );
  const { notification, getNotification, setNotification, setUserStatus } =
    useContext(AppContexts.UtilContext);

  // const { pushToRoom } = UtilsService;

  // const [socketInboxes, setSocketInboxes] = useState([]);
  // const [url, setUrl] = useState(null);

  useEffect(() => {
    refresh();
  }, []);

  useEffect(() => {
    if (!!user) {
      new ThreadStatus(user);
    }

    window.addEventListener("websocket-status", (e) => {
      setUserStatus({ ...e.status });
    });

    window.addEventListener("websocket-incoming", (e) => {
      setNotification(e.message);
    });
  }, [user]);

  // const addSocketListeners = (conn) => {
  //   setSocket(conn);

  //   conn.addEventListener("open", () => {
  //     window.dispatchEvent(new Event("websocket-connect"));

  //     conn.addEventListener("close", () => {
  //       setSocketInboxes([]);
  //       addSocketListeners(
  //         new WebSocket(
  //           "wss://c8cp9nllvl.execute-api.us-east-2.amazonaws.com/prod/",
  //         ),
  //       );
  //     });

  //     conn.addEventListener("message", (e) => {
  //       if (e.data === "") return;

  //       const message = JSON.parse(e.data);

  //       if (["update_status", "echo_status"].includes(message.action)) {
  //         setStatus(user, message);
  //       } else {
  //         if (notification?.message_id !== message.message_id) {
  //           setNotification(message);
  //         }
  //       }
  //     });

  //     // Add the personal inboxes
  //     const joinedInboxes = inbox?.inboxes || [];

  //     // Add the common inbox
  //     joinedInboxes.push(+inbox.inbox_id);

  //     // Now join all those rooms
  //     if (joinedInboxes.length > 0) {
  //       joinedInboxes.forEach((ibx) => {
  //         if (socketInboxes.includes(ibx.id)) return;

  //         conn.send(
  //           JSON.stringify({
  //             service: "notifications",
  //             action: "join",
  //             data: {
  //               room: ibx.id,
  //             },
  //           }),
  //         );

  //         setSocketInboxes((prev) => [...prev, ibx.id]);
  //       });
  //     }
  //   });
  // };

  // useEffect(() => {
  //   if (!inbox) return;

  //   let conn = new WebSocket(
  //     "wss://c8cp9nllvl.execute-api.us-east-2.amazonaws.com/prod/",
  //   );

  //   addSocketListeners(conn);

  //   let messageUrlPattern = /\/messages\/(?<thread_id>[0-9]{16}).*/;
  //   let matches = window.location.pathname.match(messageUrlPattern);

  //   let pid = (user?.user?.personal_inboxes || [])[0]?.id || null;
  //   if (!pid) {
  //     console.log("No PID:", pid);
  //     return;
  //   }

  //   if (!!matches?.groups?.thread_id) {
  //     let msg = {
  //       thread_id: +matches.groups?.thread_id,
  //       personal_inbox_id: pid,
  //       status: "viewing",
  //     };

  //     console.log("Initializing", matches?.groups?.thread_id, msg);

  //     // Update this user's initial status
  //     setStatus(user, {
  //       action: "update_status",
  //       data: msg,
  //     });

  //     // Push this users status, and get the echo from everyone else online
  //     pushToRoom("echo_status", msg);
  //   } else {
  //     setStatus(user, {
  //       action: "update_status",
  //       data: {
  //         personal_inbox_id: pid,
  //         status: "browsing",
  //       },
  //     });

  //     // Push this users status, and get the echo from everyone else online
  //     pushToRoom("echo_status", { status: "browsing", personal_inbox_id: pid });
  //   }
  // }, [inbox]);

  // useEffect(() => {
  //   console.log(userStatus);
  // }, [userStatus]);

  useEffect(() => {
    if (!!notification && window.Notification?.permission === "granted") {
      const silentTypes = ["automated", "user", "recipient"];
      if (!silentTypes.includes(notification.message_type)) {
        new window.Notification(notification.headline, {
          body: notification.message_content,
          icon: "/images/logo.png",
        });

        try {
          tone.play();
        } catch (e) {
          console.warn(
            "Tone can not be played, probably the user has not interacted with the page yet",
          );
        }
      }
    }
  }, [notification]);

  useEffect(() => {
    window.UIkit.component("ViewportBox", ViewportBox);
    window.UIkit.component("LineClamp", LineClamp);

    // window.navigation.addEventListener("navigate", (e) => {
    //   setUrl(e.destination.url);
    // });

    // setUrl(window.location.href);
  }, []);

  // useEffect(() => {
  //   if (!url) {
  //     return;
  //   }

  //   let messageUrlPattern = /\/messages\/(?<thread_id>[0-9]{16}).*/;

  //   let currentURL = new URL(url);
  //   let matches = currentURL.pathname.match(messageUrlPattern);

  //   let pid = (user?.user?.personal_inboxes || [])[0]?.id || null;
  //   if (!pid) {
  //     console.log("NO PID:", user);
  //     return;
  //   }

  //   console.log(url, pid, +matches?.groups?.thread_id);

  //   if (!!matches?.groups?.thread_id) {
  //     let msg = {
  //       thread_id: +matches.groups?.thread_id,
  //       personal_inbox_id: pid,
  //       status: "viewing",
  //     };

  //     console.log("Updating status", msg);

  //     // Push the update to everyone else
  //     pushToRoom("update_status", msg);

  //     // Update this user's status to echo
  //     setStatus(user, {
  //       action: "update_status",
  //       data: msg,
  //     });
  //   } else {
  //     setStatus(user, {
  //       action: "update_status",
  //       data: {
  //         personal_inbox_id: pid,
  //         status: "browsing",
  //       },
  //     });

  //     pushToRoom("update_status", {
  //       status: "browsing",
  //       personal_inbox_id: pid,
  //     });
  //   }
  // }, [url]);

  return (
    <div className="rbr-app-shell">
      <AnnouncementModal />
      <Sidebar />

      <div className="rbr-app-main">
        <Header />
        <Route
          path="/"
          render={(props) =>
            !loading ? <AppLayout {...props} /> : <Loading />
          }
        />
      </div>
    </div>
  );
};

export default AppLoader;
